// extracted by mini-css-extract-plugin
export default {"toast-slide-down":"Toast_toast-slide-down__OBCFv","slide-down":"Toast_slide-down__8B8CQ","toast-slide-up":"Toast_toast-slide-up__2asuf","slide-up":"Toast_slide-up__htAVr"};